import { getData, postData } from "../lib/fetchApi";
import { ORDERS_URL } from "../constants/urls";
import { defaultLocale } from "../config";

const orderService = {

    /**
     * Отримати список замовлень з пагінацією
     * @param {Object} params - параметри запиту
     * @param {string} params.lang - мова
     * @param {number} params.page - номер сторінки (за замовчуванням 1)
     * @param {number} params.limit - кількість записів на сторінку (за замовчуванням 20)
     */
    findAllByUserId: (user, lang, page = 1, limit = 20) => {
        const url = `${ORDERS_URL.FIND_ALL_BY_USER_ID}?page=${page}&limit=${limit}`;
        return getData({ url, lang });
    },

    /**
     * Отримати товари конкретного замовлення
     * @param {number} recid - ідентифікатор замовлення
     * @param {string} lang - мова
     */
    getOrderItems: (recid, lang) => {
        const url = `${ORDERS_URL.GET_ORDER_ITEMS}/${recid}/items`;
        return getData({ url, lang });
    }
}
export default orderService;
